// HÓNAP-LÉPTETŐ (`YYYY-MM`) — „‹ ›" egy sávban.
//
// MIÉRT KÖZÖS: két helyen élt bájtra ugyanez a markup (a használati-adat lap szűrősávja és a
// bevétel-előrejelzés `ForecastToolbar`-ja), a repo DRY-szabálya szerint (CLAUDE.md 4. főszabály) a 2.
// előfordulásnál a közös rétegbe kell tenni. Harmadik fogyasztó a `ListToolbar` `kind: 'month'` szűrője.
//
// A MAGASSÁG (`h-8`) SZÁNDÉKOSAN egyezik a közös `Input`/`SelectTrigger` magasságával — a szűrősávban és a
// szűrő-popoverben is a szomszédjaival egy vonalban kell állnia (korábban `h-9` volt, és kiugrott).
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { formatMonthLabelShort, shiftMonth } from '@/lib/month';
import { cn } from '@/lib/utils';

export function MonthStepper({
  month,
  onMonthChange,
  className,
}: {
  /** A megjelenített hónap `YYYY-MM` alakban. */
  month: string;
  onMonthChange: (month: string) => void;
  /** Extra osztályok a sávra (pl. `w-full` a szűrő-popoverben). */
  className?: string | undefined;
}): JSX.Element {
  const { t, i18n } = useTranslation();
  return (
    <div
      className={cn(
        'border-border input-glass text-md flex h-8 shrink-0 items-center rounded-lg border',
        className,
      )}
    >
      <button
        type="button"
        aria-label={t('common.prevMonth')}
        onClick={() => onMonthChange(shiftMonth(month, -1))}
        className="text-muted-foreground hover:text-foreground flex h-full items-center px-2 focus-visible:outline-none"
      >
        <ChevronLeftIcon className="size-4" />
      </button>
      {/* `flex-1` + `min-w-20`: a sávban tartalom-szélességű, a popoverben kitölti a mezőt.
          A MINIMUM FELÉRE CSÖKKENT (32 → 20) a RÖVIDÍTETT felirattal együtt: a léptető VEZÉRLŐ, nem tartalom,
          és a teljes hónapnév + a széles minimum miatt aránytalanul sok helyet vitt a sáv elején. A gombok, a
          betűméret és a magasság VÁLTOZATLAN — csak a felirat körüli üres hely fogyott. */}
      <span className="text-foreground min-w-20 flex-1 select-none px-0.5 text-center font-medium tabular-nums">
        {formatMonthLabelShort(month, i18n.language)}
      </span>
      <button
        type="button"
        aria-label={t('common.nextMonth')}
        onClick={() => onMonthChange(shiftMonth(month, 1))}
        className="text-muted-foreground hover:text-foreground flex h-full items-center px-2 focus-visible:outline-none"
      >
        <ChevronRightIcon className="size-4" />
      </button>
    </div>
  );
}
